/** Общие форматтеры/константы для UI. */

export const ZERO_GUID = "00000000-0000-0000-0000-000000000000";

/** Количество, до 3 знаков (штуки). */
export const ruNum = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 3 });

/** Сумма в рублях, до 2 знаков. */
export const ruRub = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 });

/**
 * ISO-момент → `01.07.2026 14:35`; пусто при некорректном вводе.
 *
 * Метки времени портала хранятся в UTC, а показывать их надо в местном времени
 * читателя — иначе «проверено в 16:40» на складе читается как позавчерашнее.
 */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return "";
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return "";
  return at.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** ISO-момент → `14:35` местного времени; пусто при некорректном вводе. */
export function fmtTime(iso: string | null | undefined): string {
  if (!iso) return "";
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return "";
  return at.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
}

/**
 * Доля части от целого в процентах; `null`, когда целого нет.
 *
 * Делить не на что — значит процента нет: `0 %` в такой ячейке читается как
 * измеренный ноль, а это разные вещи.
 */
export function sharePct(part: number, total: number): number | null {
  if (!Number.isFinite(part) || !Number.isFinite(total) || total <= 0) return null;
  return (part / total) * 100;
}

const ruPct = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

/**
 * Процент на экран: `12,3 %`, а `—` когда процента нет (`sharePct` → `null`).
 *
 * Ненулевая доля меньше 0,1 % показывается как `<0,1 %`: одна цифра после
 * запятой округлила бы её в «0,0 %», то есть в тот самый неотличимый от
 * измеренного нуля вид, ради которого `sharePct` отличает ноль от «нет
 * процента». На дашборде склада так выглядит горстка штук просрочки среди
 * десятков тысяч — ровно то, что нужно заметить.
 */
export function fmtPercent(pct: number | null): string {
  if (pct === null) return "—";
  if (pct > 0 && pct < 0.1) return "<0,1 %";
  return `${ruPct.format(pct)} %`;
}

/** ISO-дата (`2026-07-01T…`) → `01.07.2026`; пусто при некорректном вводе. */
export function fmtDate(iso: string | null | undefined): string {
  const d = (iso || "").slice(0, 10);
  if (!d.includes("-")) return "";
  const [y, m, day] = d.split("-");
  return `${day}.${m}.${y}`;
}
